import React from "react";
export const InvoiceActionIcon = () => {
  return (
    <svg
      width="2rem"
      height="2rem"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.71875 8.00052C7.71875 8.15577 7.84475 8.28177 8 8.28027C8.15525 8.28027 8.28125 8.15427 8.28125 7.99902C8.28125 7.84377 8.15525 7.71777 8 7.71777C7.84475 7.71852 7.71875 7.84452 7.71875 8.00052"
        stroke="#475CED"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.71875 5.00052C7.71875 5.15577 7.84475 5.28177 8 5.28027C8.15525 5.28027 8.28125 5.15427 8.28125 4.99902C8.28125 4.84377 8.15525 4.71777 8 4.71777C7.84475 4.71852 7.71875 4.84452 7.71875 5.00052"
        stroke="#475CED"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.71875 11.0005C7.71875 11.1558 7.84475 11.2818 8 11.2803C8.15525 11.2803 8.28125 11.1543 8.28125 10.999C8.28125 10.8438 8.15525 10.7178 8 10.7178C7.84475 10.7185 7.71875 10.8445 7.71875 11.0005"
        stroke="#475CED"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.75 4.25V11.75C14.75 13.4068 13.4068 14.75 11.75 14.75H4.25C2.59325 14.75 1.25 13.4068 1.25 11.75V4.25C1.25 2.59325 2.59325 1.25 4.25 1.25H11.75C13.4068 1.25 14.75 2.59325 14.75 4.25Z"
        stroke="#475CED"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const InvoiceRemainderIcon = () => {
  return (
    <svg
      width="8.2rem"
      height="8.2rem"
      viewBox="0 0 82 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="5" y="5" width="72" height="72" rx="36" fill="#475CED" />
      <rect
        x="2.5"
        y="2.5"
        width="77"
        height="77"
        rx="38.5"
        stroke="#475CED"
        stroke-opacity="0.3"
        strokeWidth="5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.8294 45.7497L41.7715 47.6918C42.1033 48.0236 42.5852 48.1566 43.0402 48.0418C43.4953 47.9271 43.8565 47.5816 43.9914 47.1321L47.1906 36.468C47.3316 35.9982 47.2032 35.4889 46.8564 35.142C46.5095 34.7952 46.0002 34.6668 45.5304 34.8077L34.8663 38.007C34.4167 38.1418 34.0712 38.5031 33.9565 38.9581C33.8418 39.4132 33.9747 39.895 34.3066 40.2269L36.2487 42.169V45.7497H39.8294Z"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.834 50.1665L29.334 52.6665"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.8991 52.7676L34.2324 54.4342"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.3327 46L27.666 47.6667"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26 41C26 32.7157 32.7157 26 41 26C49.2843 26 56 32.7157 56 41C56 49.2843 49.2843 56 41 56"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const InvoiceSentSuccessIcon = () => {
  return (
    <svg
      width="8.2rem"
      height="8.2rem"
      viewBox="0 0 82 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="5" y="5" width="72" height="72" rx="36" fill="#27AE60" />
      <rect
        x="2.5"
        y="2.5"
        width="77"
        height="77"
        rx="38.5"
        stroke="#27AE60"
        stroke-opacity="0.3"
        strokeWidth="5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.2492 31.4741C56.0242 32.1591 56.0968 33.3441 55.4118 34.1241L41.0367 50.3741C40.8707 50.5619 40.6688 50.7144 40.4428 50.8227C40.2169 50.931 39.9715 50.993 39.7212 51.0049C39.4709 51.0168 39.2207 50.9784 38.9855 50.8919C38.7503 50.8055 38.5348 50.6728 38.3517 50.5016L28.9767 41.7516C28.6161 41.4118 28.4047 40.9429 28.3887 40.4476C28.3727 39.9523 28.5534 39.4708 28.8914 39.1083C29.2294 38.7459 29.6971 38.532 30.1924 38.5134C30.6876 38.4948 31.17 38.6731 31.5342 39.0091L39.5092 46.4341L52.6092 31.6341C52.7726 31.4494 52.9708 31.2987 53.1924 31.1906C53.4141 31.0825 53.6549 31.0192 53.9011 31.0044C54.1472 30.9895 54.3939 31.0234 54.6269 31.104C54.86 31.1846 55.0749 31.3104 55.2593 31.4741H55.2492Z"
        fill="white"
      />
    </svg>
  );
};
